export type { CopyContext, CopyResolver, CopyResult } from './copy'
export { FALLBACK_BY_SEGMENT, SIGNUP_MODAL_COPY } from './copy'
export type { SignupModalEligibilityQuery } from './eligibility'
export { isSignupModalExperimentEligible } from './eligibility'
export { SIGNUP_MODAL_EVENTS } from './events'
export type { SignupModalVariant } from './flag'
export {
  isSignupModalVariant,
  SIGNUP_MODAL_FLAG_KEY,
  SIGNUP_MODAL_METRICS_API_ROUTE,
  SIGNUP_MODAL_VARIANTS,
} from './flag'
export type { ResolveVariantInput, ResolveVariantResult } from './resolve-variant'
export { resolveSignupModalVariant } from './resolve-variant'
export type { DeriveSegmentInput, SignupModalSegment } from './segment'
export { deriveSignupModalSegment, SIGNUP_MODAL_SEGMENTS } from './segment'
